import { connect } from 'socket.io-client';
import ConsoleParent from './consoleParent';
import ConsoleUI from './consoleUI';

class ConsoleTerminal extends ConsoleParent {

    protected initUi(el: JQuery): void {
        this.ui = new ConsoleUI(el);
        this.ui.setConnectionStatus(true);
    }

    protected initConsole(url: String): void {

        this.console = connect(url + 'console', {
            path: `/${window.regionPrefix}/ws/legacy/socket.io`,
            reconnectionAttempts: 7,
            reconnectionDelayMax: 7000,
            randomizationFactor: 0.7,
            transports: ['websocket', 'polling']
        });
        this.console.on('connect', () => {
            $('[data-console]').each((i, el) => {
                const id: any = $(el).data('console-id');
                this.console.emit('open', id);
            });
        });

        ['stdout', 'stderr', 'event'].forEach((key => {
            this.console.on(key, (text) => {
                this.ui.writeToConsole(text);
            });
        }));

        this.ui.onSubmit(this.submit.bind(this));
    }

    protected submit(text: string): void {
        this.ui.clearInput();
        this.console.emit('input', text + '\n');
    }
}

export default ConsoleTerminal;
